import React, { useState } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon, CheckCircleIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María González',
    city: 'Buenos Aires',
    text: 'Mi perro tenía problemas digestivos constantes. Después de un mes con las recetas, su salud cambió por completo. Vale cada peso.'
  }, {
    name: 'Carlos Ramírez',
    city: 'Córdoba',
    text: 'Mi gata está más saludable y su pelaje brilla como nunca. Las recetas son simples y prácticas, las hago en minutos.'
  }, {
    name: 'Ana Martínez',
    city: 'Rosario',
    text: 'La calculadora de raciones me ayudó a controlar el peso de mi perro. Súper completo y profesional.'
  }, {
    name: 'Luis Fernández',
    city: 'Mendoza',
    text: 'Mi perro recuperó energía y dejó de tener alergias. El mejor cambio que he hecho como dueño.'
  }, {
    name: 'Camila Torres',
    city: 'La Plata',
    text: 'Las recetas para problemas renales me salvaron. Mi gato de 12 años está más activo y feliz que nunca.'
  }, {
    name: 'Diego Morales',
    city: 'Mar del Plata',
    text: 'Increíble la cantidad de contenido. Por menos del precio de una bolsa de alimento, tengo recetas para meses.'
  }, {
    name: 'Valentina Rojas',
    city: 'Salta',
    text: 'Mis dos perros tienen necesidades distintas y aquí encontré recetas adaptadas para cada uno. Excelente compra.'
  }, {
    name: 'Andrés Silva',
    city: 'Tucumán',
    text: 'El manual de primeros auxilios me dio mucha tranquilidad. Es un material muy completo y bien explicado.'
  }, {
    name: 'Sofía Benítez',
    city: 'Neuquén',
    text: 'Empecé con las recetas hipoalergénicas y mi perra dejó de rascarse. Por fin encontré algo que funciona.'
  }, {
    name: 'Martín Acosta',
    city: 'Bahía Blanca',
    text: 'Llevo 2 meses cocinando para mis dos perros y la diferencia es notoria. Más energía y menos visitas al veterinario.'
  }];
  const [index, setIndex] = useState(0);
  const prev = () => setIndex(i => i === 0 ? testimonials.length - 1 : i - 1);
  const next = () => setIndex(i => i === testimonials.length - 1 ? 0 : i + 1);
  const t = testimonials[index];
  return <section className="bg-white py-10 md:py-14" data-id="element-93">
      <div className="max-w-3xl mx-auto px-5" data-id="element-94">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-ink text-center mb-6" data-id="element-95">
          Lo que dicen quienes ya lo tienen
        </h2>

        <div className="relative" data-id="element-96">
          <div className="bg-gray-50 rounded-2xl p-8 md:p-10 min-h-[260px] flex flex-col justify-center" data-id="element-97">
            <div className="flex gap-1 mb-4 justify-center" data-id="element-98">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-99" />)}
            </div>

            <p className="text-lg text-gray-700 text-center mb-6 leading-relaxed italic" data-id="element-100">
              "{t.text}"
            </p>

            <div className="text-center" data-id="element-101">
              <p className="font-semibold text-gray-800" data-id="element-102">{t.name}</p>
              <div className="flex items-center justify-center gap-1.5 text-sm text-gray-500 mt-1" data-id="element-103">
                <span data-id="element-104">{t.city}, Argentina</span>
                <span data-id="element-105">·</span>
                <span className="flex items-center gap-1" data-id="element-106">
                  <CheckCircleIcon className="w-3.5 h-3.5 text-forest" data-id="element-107" />
                  Compra verificada
                </span>
              </div>
            </div>
          </div>

          <button onClick={prev} aria-label="Anterior" className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-6 w-10 h-10 bg-white rounded-full shadow-md flex items-center justify-center hover:bg-gray-50 transition-colors" data-id="element-108">
            <ChevronLeftIcon className="w-5 h-5 text-gray-700" data-id="element-109" />
          </button>

          <button onClick={next} aria-label="Siguiente" className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-6 w-10 h-10 bg-white rounded-full shadow-md flex items-center justify-center hover:bg-gray-50 transition-colors" data-id="element-110">
            <ChevronRightIcon className="w-5 h-5 text-gray-700" data-id="element-111" />
          </button>

          <div className="flex justify-center gap-2 mt-6 flex-wrap" data-id="element-112">
            {testimonials.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Ir al testimonio ${i + 1}`} className={`w-2 h-2 rounded-full transition-colors ${i === index ? 'bg-forest' : 'bg-gray-300'}`} data-id="element-113" />)}
          </div>
        </div>
      </div>
    </section>;
}